import * as React from 'react';
import { ITableConfig } from '../../common/table';
import PagedResultSet from '../../../models/common/PagedResultSet';
import User from '../../../models/User';
// import { Button } from '@blueprintjs/core';
import { IRootState } from 'src/reducers';
import selectors from 'src/selectors';
import actions from 'src/actions';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
// import Card from 'src/components/common/Card.redesign';
import CardContainer from 'src/components/common/CardContainer.redesign';
import RHFLegend from 'src/components/controls/tempRHFControls/RHFLegend';
import Button from 'src/components/controls/forms/redesign/FormButton';
import Card from 'src/components/common/Card.redesign';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
import Filter from 'src/components/common/Filter';
import { ODataOptions } from 'src/util/ODataBuilder';
// import RHFLegend from 'src/components/controls/tempRHFControls/RHFLegend';

interface IAdminUserPageStateProps {
    isLoading: boolean;
    users: PagedResultSet<User> | undefined;
    tableConfig: ITableConfig;
}

export interface IAdminUserPageDispatchProps {
    getUsers: (options: ODataOptions, resetPage?: boolean) => void;
    incrementUsers: () => void;
    initUsers: () => void;
    navigate: (path: string) => void;
}

type IAdminUserPageProps = IAdminUserPageStateProps & IAdminUserPageDispatchProps;

class AdminUserPage extends React.Component<IAdminUserPageProps> {
    constructor(props: IAdminUserPageProps) {
        super(props);
    }

    componentDidMount() {
        this.props.getUsers(new ODataOptions(), true);
    }

    componentWillUnmount() {
        this.props.initUsers();
    }

    editUser(userId: number) {
        console.log('Edit User', userId);
        this.props.navigate(`/admin/edit-user/${userId}`);
    }

    displayUsers() {
        if (this.props.users?.items && this.props.users.items.length > 0) {
            return this.props.users.items.map((user: User, index: number) => {
                return (
                    <Card
                        key={index}
                        badge={`User #${user.username}`}
                        actions={[{ text: 'Edit User', action: () => this.editUser(user.id) }]}
                        style={{ marginTop: '1rem' }}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ width: '30%' }}>{`${user.firstName} ${user.lastName}`}</div>
                            <div style={{ width: '30%' }}>{user.type?.name}</div>
                            <div style={{ width: '25%' }}>{user.role?.role}</div>
                            <div style={{ width: '15%' }}>{user.lmsNumber}</div>
                        </div>
                    </Card>
                );
            });
        } else {
            return <div>No Users available</div>;
        }
    }

    handleUserFilterChanged = (options: ODataOptions) => {
        console.log('at component', options);
        this.props.initUsers();
        this.props.getUsers(options, true);
    };

    public render() {
        const addUser = () => this.props.navigate('/admin/create-user');
        const { users } = this.props;
        let isOnLastPage = false;
        if (users) {
            isOnLastPage = users.pageNumber * users.pageSize < users.totalRecords;
        }

        return (
            <>
                <RHFLegend title="User Administration" />
                <Page>
                    <Page.Section>
                        <Panel fitPanelToScreen={true} customSize={2}>
                            <Filter
                                filterItems={[
                                    { group: 1, text: 'First Name', orderName: 'firstName', orderDirection: 'descending' },
                                    { group: 1, text: 'Last Name', orderName: 'lastName', orderDirection: 'descending' },
                                    { group: 1, text: 'Username', orderName: 'username', orderDirection: 'descending' },
                                    { group: 1, text: 'Office', orderName: 'office', orderDirection: 'descending' },
                                    { group: 1, text: 'User Role', orderName: 'role', orderDirection: 'descending' },
                                    { group: 1, text: 'LM Number', orderName: 'lmsNumber', orderDirection: 'descending' },
                                ]}
                                onFilterChanged={this.handleUserFilterChanged}
                            />
                            <div style={{ display: 'flex' }}>
                                <div className="mr-2" style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div style={{ padding: '1rem', width: '30%' }}>
                                            <div>
                                                <b>Name</b>
                                            </div>
                                        </div>
                                        <div style={{ padding: '1rem', width: '30%' }}>
                                            <div>
                                                <b>Type</b>
                                            </div>
                                        </div>
                                        <div style={{ padding: '1rem', width: '25%' }}>
                                            <div>
                                                <b>Role</b>
                                            </div>
                                        </div>
                                        <div style={{ padding: '1rem', width: '15%' }}>
                                            <div>
                                                <b>LM Number</b>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <CardContainer
                                showNextPagePanel={isOnLastPage}
                                nextPageAction={this.props.incrementUsers}
                                style={{ overflowY: 'scroll', maxHeight: '56vh' }}
                            >
                                {this.displayUsers()}
                            </CardContainer>
                        </Panel>
                    </Page.Section>
                </Page>
                <Button onClick={addUser} text="Create User" />
            </>
        );
    }
}

const mapStateToProps = (state: IRootState) => ({
    isLoading: selectors.user.isLoadingUsers(state),
    users: selectors.user.users(state),
    tableConfig: selectors.user.adminUsersPageTableConfig(state),
});

const mapDispatchToProps: IAdminUserPageDispatchProps = {
    getUsers: (options: ODataOptions, resetPage?: boolean) => actions.user.getUsersForPage(options, resetPage),
    incrementUsers: () => actions.user.incrementUsers(),
    initUsers: () => actions.user.initUsers(),
    navigate: (path: string) => push(path),
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminUserPage);



// WEBPACK FOOTER //
// ./src/components/admin/sections/AdminUsersPage.tsx